import React from 'react';
import FormCategoria from '../../components/forms/formCategoria';

const NewCategoria = (props) => {
    return (
        <FormCategoria/>
    );
}
 
export default NewCategoria;